import { render } from "./CertificatesPage.vue?vue&type=template&id=e3ce7a32&scoped=true"
import script from "./CertificatesPage.vue?vue&type=script&lang=js"
export * from "./CertificatesPage.vue?vue&type=script&lang=js"

import "./CertificatesPage.vue?vue&type=style&index=0&id=e3ce7a32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3ce7a32"]])

export default __exports__